import { GridColumn } from 'src/components/GridWrapper';
import CurrentDocTotal from 'src/sections/view_invoices/CurrentDocTotal';

const percentRecDolColumns: GridColumn<any>[] = [
  {
    field: 'poTotal',
    title: 'PO Total',
    width: '150px',
    format: '{0:c}',
    dataType: 'dollar',
    menu: false,
    headerCellTooltip: 'Total $ amount on PO',
  },
  {
    field: 'currentDocTotal',
    title: 'Current Doc Total',
    width: '150px',
    format: '{0:c}',
    dataType: 'dollar',
    menu: false,
    headerCellTooltip: 'Total $ amount on current doc',
    component: CurrentDocTotal,
  },
  {
    field: 'docTotal',
    title: 'All Doc Total',
    width: '150px',
    format: '{0:c}',
    dataType: 'dollar',
    menu: false,
    headerCellTooltip: 'Total $ amount for both in progress and completed docs associated with PO',
  },
];

export default percentRecDolColumns;
